import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var content = {
  name: "1qdjuog",
  styles: "max-width:1020px;margin:0 auto;"
};
export var contentDivider = /*#__PURE__*/css("border-top:0;", media('>=tablet'), "{margin-top:10px;}");
export var breadcrumbs = /*#__PURE__*/css("margin:10px 0 10px 10px;", media('>=tablet'), "{margin-bottom:0;}", media('>=desktop'), "{margin-left:0;}");